import { useState } from "react";

type initialErrorStatus = {
  open: boolean;
  title?: string;
  message?: string;
  tone?: string;
  notClose?: boolean;
  children?: JSX.Element;
  primaryAction?: {
    content: string;
    onAction?: () => void;
    loading?: boolean;
    url?: string;
  };
  secondaryActions?: { content: string; onAction?: () => void }[];
  lists?: string[];
};

export const useModals = () => {
  const [modals, setModals] = useState<initialErrorStatus>({
    open: false,
    title: "",
    message: "",
  });
  const changeModals = (props: initialErrorStatus) => {
    setModals((prev) => {
      return { ...prev, ...props };
    });
  };
  return { modals, changeModals };
};

export type modalsType = ReturnType<typeof useModals>;
